



















































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { PaymentInfoModel } from '@/app/shared/models';
@Component
export default class ContentPaymentComponent extends Vue {
  @Prop(Object) readonly paymentInfo!: PaymentInfoModel;
  @Prop(Boolean) readonly showDetails!: boolean;

  private get refs() {
    return refsService;
  }
  private get branch() {
    return this.paymentInfo?.BranchNumber && this.paymentInfo?.BranchDigit
      ? `${this.paymentInfo.BranchNumber}-${this.paymentInfo.BranchDigit}`
      : this.paymentInfo.BranchNumber || this.paymentInfo.BranchDigit || '--';
  }
  private get account() {
    return this.paymentInfo?.AccountNumber && this.paymentInfo?.AccountDigit
      ? `${this.paymentInfo.AccountNumber}-${this.paymentInfo.AccountDigit}`
      : this.paymentInfo.AccountNumber || this.paymentInfo.AccountDigit || '--';
  }
  private get accountType() {
    return this.refs._.find(this.refs.static.accountTypes, {
      value: this.paymentInfo.AccountType,
    })?.label;
  }
  private get financialInstitutionCode() {
    const institution = this.refs.static.banks.find(
      (bank) => bank.value == this.paymentInfo.FinancialInstitutionCode
    );
    return institution
      ? `${institution.value} - ${institution.label}`
      : undefined;
  }

  private get cardExpiration() {
    return this.refs
      .moment(this.paymentInfo.CardExpiration, 'YYYYMM')
      .format('MM/YYYY');
  }
  private get document() {
    return this.paymentInfo.DocumentType && this.paymentInfo.Document
      ? `${this.paymentInfo.DocumentType} - ${this.paymentInfo.Document}`
      : undefined;
  }

  private get StatusCharge() {
    return this.paymentInfo.StatusChargePaymentMethod?.[0]
      ? this.paymentInfo.StatusChargePaymentMethod[0]
      : undefined;
  }
}
